import { MediasLogo, type MediasVariant } from "~/features/navigation/components/TopBar/MediasLogo";
import { CompanyLogo } from "~/domains/company/components/CompanyLogo";
import { userIsPublic, userIsRegistered } from "~/domains/user/utils/roles";
import { styled } from "~/common/mui";

const HeaderBorder = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(3),
    gap: theme.spacing(4),
  },
}));

const CompanyLogoContainer = styled("div")({
  marginLeft: "auto",
  flex: "none",
});

const CustomModalHeader = () => {
  let userRole: MediasVariant;
  if (userIsPublic()) {
    userRole = "general";
  } else if (userIsRegistered()) {
    userRole = "plus";
  } else {
    userRole = "business";
  }

  return (
    <HeaderBorder>
      <MediasLogo variant={userRole} />
      <CompanyLogoContainer>
        <CompanyLogo />
      </CompanyLogoContainer>
    </HeaderBorder>
  );
};

export default CustomModalHeader;
